// extracted by mini-css-extract-plugin
export default {"Container":"ErrorsModal_Container__Kqn4-"};